import InputBase from "@material-ui/core/InputBase";

import OutlinedInput from "./OutlinedInput";

export default OutlinedInput(InputBase);
